<template>
  <div id="add-update-packet-dialog" class="custom-modal">
    <transition name="el-fade-in" mode="out-in">
      <HolaconLottie v-if="loading == 'updateScreenLoading' && packet == null" key="create-loading" />
      <el-row v-else key="content-loading">
        <div class="modal-body">
          <el-row v-if="packet" :gutter="10" class="tab-packet-contents">
            <el-col :span="16">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.title") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.titleMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-input type="text" v-model="packet.title"></el-input>
                <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.segmentation") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.segmentationMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-select v-model="packet.tagID">
                  <el-option v-for="(tag, index) in tagList" :key="index" :label="tag.title" :value="tag.id">
                    <i class="fas fa-circle mr-1" :style="'color: ' + tag.color"></i>
                    <span>{{ tag.title }}</span>
                  </el-option>
                </el-select>
                <span class="error">{{ $errorMessage("tagID", validationErrors) }}</span>
              </div>
            </el-col>
            <el-col :span="24" class="mt-3">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.content") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.contentMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <quill-editor ref="myQuillEditor" @ready="onEditorReady($event)" :options="editorOption" v-model="packet.details" />
                <span class="error">{{ $errorMessage("details", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10" v-if="packet">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container" v-if="currentForm.paymentInfo.formRegistrationType == 1">
                <div class="section-header" @click="pricingDock = !pricingDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label :class="{ 'text-danger': validationErrors.some(x => x.key.includes('priceOptions')) }">{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.pricing") }}</label>
                    </div>
                    <span v-html="$t('registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.pricingMsg')"></span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="pricingDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="pricingDock">
                    <div class="pricing-list-title custom-grid-table-header">
                      <div></div>
                      <div>{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.title") }}</div>
                      <div>{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.startDate") }}</div>
                      <div>{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.endDate") }}</div>
                      <div>{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.price") }}</div>
                      <div class="text-center">{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.view") }}</div>
                      <div></div>
                    </div>
                    <div id="pricing-list-container">
                      <div class="item" style="margin-bottom:8px">
                        <i class="el-icon-s-grid burger me passive"></i>
                        <div class="price-title"><el-input v-model="packet.basePriceTitle"></el-input></div>
                        <div></div>
                        <div></div>
                        <div>
                          <template v-if="currentForm.paymentInfo.formRegistrationType == 1">
                            <MoneyInput :min="0" :max="99999" :fixed="2" v-model="packet.price" :disabled="currentForm.paymentInfo.formRegistrationType == 0" clearable>
                              <template slot="append">{{ $enums.currency.find(k => k.value == currentForm.paymentInfo.currency).title }}</template>
                            </MoneyInput>
                          </template>
                          <template v-else>
                            <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.free") }}</span>
                          </template>
                        </div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                    <draggable id="pricing-list-container" :list="packet.priceOptions" tag="div" handle=".el-icon-s-grid" class="list-group-o" v-bind="dragOptions" @start="drag = true" @end="drag = false">
                      <div class="item" v-for="(option, index) in packet.priceOptions" :key="index" :class="{ passive: !option.isActive }">
                        <i class="el-icon-s-grid burger me"></i>
                        <div class="price-title" v-if="option"><el-input v-model="option.title"></el-input></div>
                        <div v-if="option"><el-date-picker :class="$inputError('priceOptions[' + index + '].startDate', validationErrors)" :format="datePickerDisplayFormat()" v-model="option.startDate" type="date" :placeholder="$t('registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.chooseDate')"></el-date-picker></div>
                        <div v-if="option"><el-date-picker :class="$inputError('priceOptions[' + index + '].endDate', validationErrors)" :format="datePickerDisplayFormat()" v-model="option.endDate" type="date" :placeholder="$t('registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.chooseDate')"></el-date-picker></div>
                        <div v-if="option">
                          <MoneyInput :min="0" :max="99999" :fixed="2" v-model="option.price" clearable>
                            <template slot="append">{{ getEnumsDisplay("Currency", currentForm.paymentInfo.currency) }}</template>
                          </MoneyInput>
                        </div>
                        <div v-if="option" class="justify-content-center"><el-switch v-model="option.isActive"></el-switch></div>
                        <div v-if="option">
                          <el-popconfirm @confirm="packet.priceOptions.splice(index, 1)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                            <el-button circle icon="fas fa-trash" slot="reference" type="danger" size="small"></el-button>
                          </el-popconfirm>
                        </div>
                      </div>
                    </draggable>
                    <div class="add-pricing-btn mt-2">
                      <el-button type="primary" icon="fas fa-plus" round size="small" v-if="false" @click="openUpgradeDialog">{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.newPriceOption") }}</el-button>
                      <el-button type="primary" icon="fas fa-plus" round size="small" v-else @click="addPricingOption">{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.newPriceOption") }}</el-button>
                    </div>
                  </div>
                </transition>
              </div>

              <div class="custom-section-container">
                <div class="section-header" @click="packageTypeDock = !packageTypeDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label :class="{ 'text-danger': validationErrors.some(x => x.key.includes('packetType')) }">{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.packageType") }}</label>
                      <!-- <el-tooltip content="Content" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <template v-if="$i18n.locale == 'tr'">
                      <span class="text-danger" v-if="validationErrors.some(x => x.key.includes('dayRestriction'))">
                        Paket Tipinde
                        <span v-if="validationErrors.some(x => x.key.includes('dayRestriction'))">{{ validationErrors.filter(x => x.key.includes("dayRestriction")).length }} hatalı alan bulunmaktadır.</span>
                      </span>
                    </template>
                    <template v-if="$i18n.locale == 'en'">
                      <span class="text-danger" v-if="validationErrors.some(x => x.key.includes('dayRestriction'))">
                        There are
                        <span v-if="validationErrors.some(x => x.key.includes('dayRestriction'))">{{ validationErrors.filter(x => x.key.includes("dayRestriction")).length }} faulty fields in the Package Type.</span>
                      </span>
                    </template>

                    <span v-html="$t('registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.packageMsg')"></span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="packageTypeDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="packageTypeDock">
                    <div class="registerform-input-container mt-2">
                      <div class="mb-3">
                        <el-select v-model="packet.packetType" :class="$inputError('packetType', validationErrors)">
                          <el-option v-for="(item, index) in getEnums.find(x => x.title == 'RegistrationFormPacketType').enums" :key="index" :label="item.displayName" :value="item.key"></el-option>
                        </el-select>
                        <span class="error">{{ $errorMessage("packetType", validationErrors) }}</span>
                      </div>
                    </div>
                    <div class="packet-type-list-title custom-grid-table-header" v-if="packet.packetType != null && packet.packetType == 1">
                      <div></div>
                      <div>{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.title") }}</div>
                      <div>{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.startDate") }}</div>
                      <div>{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.view") }}</div>
                      <div></div>
                    </div>
                    <draggable id="packet-type-list-container"  v-if="packet.packetType != null && packet.packetType == 1" :list="packet.dayRestrictions" tag="div" handle=".el-icon-s-grid" class="list-group-o" v-bind="dragOptions" @start="drag = true" @end="drag = false">
                      <div class="item" v-for="(option, index) in packet.dayRestrictions" :key="index" :class="{ passive: !option.isActive }">
                        <i class="el-icon-s-grid burger me"></i>
                        <div v-if="option"><el-input v-model="option.title" :class="$inputError('dayRestrictions[' + index + '].Title', validationErrors)"></el-input></div>
                        <div v-if="option"><el-date-picker :format="datePickerDisplayFormat()" v-model="option.date" type="date" :class="$inputError('dayRestrictions[' + index + '].Date', validationErrors)" :placeholder="$t('registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.chooseDate')"></el-date-picker></div>
                        <div v-if="option"><el-switch v-model="option.isActive"></el-switch></div>

                        <div v-if="option">
                          <el-tooltip class="" effect="dark" :content="$t('event.buttons.delete')" placement="top-start">
                            <el-popconfirm @confirm="packet.dayRestrictions.splice(index, 1)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                              <el-button circle icon="fas fa-trash" slot="reference" type="danger" size="small"></el-button>
                            </el-popconfirm>
                          </el-tooltip>
                        </div>
                      </div>
                    </draggable>
                    <div class="add-pricing-btn mt-2" v-if="packet.packetType != null && packet.packetType == 1">
                      <el-button type="primary" icon="fas fa-plus" round size="small" v-if="false" @click="openUpgradeDialog">{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.addNewDay") }}</el-button>
                      <el-button type="primary" icon="fas fa-plus" round size="small" @click="addDayRestrictions" v-else>{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.addNewDay") }}</el-button>
                    </div>
                  </div>
                </transition>
              </div>

              <div class="custom-section-container">
                <div class="section-header" @click="settingsDock = !settingsDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.settings") }}</label>
                      <!-- <el-tooltip content="Content" placement="top">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.settingsMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="settingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="settingsDock">
                    <div class="custom-set-container" :class="packet.isActive ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i class="fa" :class="packet.isActive ? 'fa-eye' : 'fa-eye-slash'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.view") }}
                            <!-- <el-tooltip content="Content" placement="top">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.viewMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="packet.isActive"></el-switch>
                      </div>
                    </div>

                    <div class="custom-set-container" :class="packet.isPublic ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i :class="packet.isPublic ? 'fas fa-ticket-alt' : 'fas fa-ticket-alt'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("generic.status") }}
                            <!-- <el-tooltip content="Content" placement="top">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span v-html="$t('registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.situationMsg')"></span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="packet.isPublic"></el-switch>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-row>
    </transition>

    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading' && packet != null">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.close") }}</el-button>
        <template v-if="id != null">
          <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
            <el-button slot="reference" type="danger" icon="fas fa-trash">{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.delete") }}</el-button>
          </el-popconfirm>
        </template>
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'packetSave'" :disabled="loading == 'packetSave'" @click="savePacket">{{ $t("registrationManagement.registrationForm.registerFormDialog.packages.addUpdateRegisterationPackage.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { quillEditor } from "vue-quill-editor";
import MoneyInput from "./Inputs/MoneyInput.vue";
export default {
  props: ["id", "formId"],
  components: {
    quillEditor,
    draggable,
    MoneyInput
  },
  data() {
    return {
      packageTypeDock: false,
      pricingDock: false,
      settingsDock: false,
      packet: null,
      loading: false,
      timeout: null,
      drag: false,
      currDate: new Date().getTime(),
      validationErrors: [],
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            [{ indent: "-1" }, { indent: "+1" }]
          ],
          syntax: {
            highlight: text => hljs.highlightAuto(text).value
          }
        }
      }
    };
  },
  computed: {
    eventPermissions() {
      return this.$store.getters.getEventPermission;
    },
    currentForm() {
      return this.$store.getters.getCurrentRegisterForm;
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    packetForm() {
      return this.$store.getters.getRegistrationPacketForm;
    },
    currentRegisterForm() {
      return this.$store.getters.getCurrentRegisterForm;
    },
    tagList() {
      return this.$store.getters.getTagsList;
    },
    getEnums() {
      return this.$store.getters.getEnums;
    }
  },
  async created() {
    this.checkedId();
  },
  methods: {
    deleteItem() {
      this.$emit("deleteMe", this.id);
      this.$emit("closeDialog");
    },
    async savePacket() {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.loading = "packetSave";
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("addOrUpdateRegisterPacket", this.packet);
        this.validationErrors = res.data.validationErrors;
        if (!res.data.alert.hasError) {
          this.closeMe();
        }
        this.loading = false;
      }, 500);
    },

    closeMe() {
      this.$emit("closeDialog");
    },
    addDayRestrictions() {
      var day = null;
      if (this.$i18n.locale == "tr") {
        day = "Yeni Gün";
      } else {
        day = "New Day";
      }
      this.packet.dayRestrictions.push({
        id: null,
        title: day,
        date: null,
        isActive: true
      });
    },
    addPricingOption() {
      this.packet.priceOptions.push({
        id: null,
        title: this.$t("generic.newOption"),
        startDate: null,
        endDate: null,
        price: 0,
        isActive: true
      });
    },
    onEditorReady(editor) {
      editor.getModule("toolbar").addHandler("image", () => {
        this.selectLocalImage(editor);
      });
    },
    async checkedId() {
      this.loading = "updateScreenLoading";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$nextTick(async () => {
          await this.$store.dispatch("getTags");
          if (this.id) {
            this.packet = JSON.parse(JSON.stringify(this.currentRegisterForm.packets.find(x => x.id == this.id)));
          } else {
            this.packetForm.basePriceTitle = this.$t('generic.standard');
            this.packet = JSON.parse(JSON.stringify(this.packetForm));
            this.packet.categoryID = this.formId;
            this.packet.price = 0;
            this.packet.title = null;
          }

          if (this.currentForm.paymentInfo.formRegistrationType == 0) {
            this.packet.price = 0;
          }
        });
        this.loading = false;
      }, 500);
    }
  },
  watch: {
    id() {
      this.checkedId();
    }
  }
};
</script>

<style lang="less">
.packet-type-list-title {
  grid-template-columns: 30px 1fr 1fr 90px 90px;
}
#packet-type-list-container {
  display: flex;
  flex-direction: column;
  .item {
    .el-date-editor {
      width: 100%;
    }
    i.el-icon-s-grid {
      box-sizing: border-box;
      font-size: 20px;
      color: #505763;
      cursor: grab;
    }
    transition: all 0.5s;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    background-color: #f1f1f1;
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: unset;
    }
    &.passive {
      background-color: #fff2f2 !important;
    }

    padding: 10px;
    display: grid;
    grid-template-columns: 30px 1fr 1fr 90px 90px;
    gap: 0.5rem;
    align-items: center;
  }
  // .item {
  //   display: grid;
  //   grid-template-columns: 3fr 3fr 1fr 1fr;
  //   padding: 10px;
  //   margin-top: 1rem;
  //   border: 1px solid #ccc;
  //   margin-bottom: 0.5rem;
  //   align-items: center;
  //   gap: 0.5rem;
  //   & > .price-title {
  //     font-weight: bold;
  //   }
  //   .el-date-editor {
  //     width: 100%;
  //   }
  //   & > div {
  //     flex-shrink: 0;
  //     display: flex;
  //     flex-direction: row;
  //     gap: 0.5rem;
  //     align-items: center;
  //     i.burger {
  //       &.me {
  //         color: #ccc;
  //       }
  //       font-size: 20px;
  //     }
  //   }
  //   .el-input {
  //     input {
  //       border-radius: 0;
  //     }
  //   }
  //   & > div:last-child {
  //     justify-self: flex-end;
  //   }
  // }
}
.pricing-list-title {
  grid-template-columns: 30px 1.3fr 1fr 1fr 1.1fr 90px 60px;
  & > div {
    flex-shrink: 0;
  }
}
#pricing-list-container {
  .item {
    transition: all 0.5s;
    border-radius: 8px;
    background-color: #f1f1f1;
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: unset;
    }
    &.passive {
      background-color: #fff2f2 !important;
    }
    display: grid;
    grid-template-columns: 30px 1.3fr 1fr 1fr 1.1fr 90px 60px;
    padding: 10px;
    align-items: center;
    gap: 0.5rem;
    & > .price-title {
      font-weight: bold;
    }
    .el-date-editor {
      width: 100%;
    }
    & > div {
      flex-shrink: 0;
      display: flex;
      flex-direction: row;
      gap: 0.5rem;
      align-items: center;
    }

    i.burger {
      &.passive {
        opacity: 0.5;
        cursor: not-allowed !important;
      }

      &.me {
        box-sizing: border-box;
        font-size: 20px;
        color: #505763;
        cursor: grab;
      }
    }

    & > div:last-child {
      justify-self: flex-end;
    }
  }
}
.add-pricing-btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/register-form/addOrUpdateRegistrationPacket.vue